export default "__VITE_ASSET__DQ4LRl$4__"